/**
 *
 * Asynchronously loads the component for Fonts
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'));
